var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region Schedule - Ctor
    ns.Schedule = function Schedule(semesterStartDate, semesterEndDate, schedules) {
        this.weeks = [];

        var startDate = semesterStartDate;
        var endDate = semesterEndDate;

        if (schedules && schedules.length > 0) {
            var first = schedules[0];
            var last = schedules[schedules.length - 1];

            var firstStart = first.firstPeriodStartDate
                             ? first.firstPeriodStartDate
                             : first.secondPeriodStartDate;

            var lastStart = last.firstPeriodStartDate
                            ? last.firstPeriodStartDate
                            : last.secondPeriodStartDate;

            startDate = startDate < firstStart
                        ? startDate
                        : firstStart;

            endDate = endDate > lastStart
                      ? endDate
                      : lastStart;
        }

        var mStartDate = moment(startDate).startOf('week');
        var mEndDate = moment(endDate).startOf('week');

        while (mStartDate.isBefore(mEndDate)) {
            var weekModel = new ns.ScheduleWeek(
                mStartDate,
                this.findWeekSchedule(schedules, mStartDate));

            this.weeks.push(weekModel);

            mStartDate.add('weeks', 1);
        }
    }
    // #endregion

    // #region Schedule - Methods
    ns.Schedule.prototype.findWeekSchedule = function (schedules, mStartDate) {
        var idx = 0;
        var sch = [];
        while (!!schedules && (idx < schedules.length)) {

            var currentSchedule = schedules[idx];

            var currentStart = null;

            if (currentSchedule.firstPeriodStartDate) {
                currentStart = moment(currentSchedule.firstPeriodStartDate).startOf('week');
            } else {
                currentStart = moment(currentSchedule.secondPeriodStartDate).startOf('week');
            }

            if (currentStart.isAfter(mStartDate)) {
                break;
            }

            if (currentStart.isSame(mStartDate)) {
                sch.push(currentSchedule);
            }

            idx++;
        }

        return sch;
    }
    // #endregion

})(webooker_acivity_models);